var svgmoji = require('svgmoji');
module.exports = svgmoji;
